// @flow
import * as React from 'react';
import { X } from '@elastic-internal/lucide-react';

import LucideIconButton from '../lucide-icon-button';

export type Props = $ReadOnly<{
  onClick: (SyntheticMouseEvent<Node>) => void,
  small?: boolean,
  color?: string,
  style?: { +[string]: string | number },
  'data-testid'?: string,
}>;

const CloseButton = ({
  onClick,
  small,
  color,
  style,
  'data-testid': dataTestid,
}: Props): React.Node => (
  <LucideIconButton
    LucideIcon={X}
    onClick={onClick}
    color={color}
    small={small}
    style={style}
    data-testid={dataTestid}
  />
);

export default CloseButton;
